import React, { useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";

const SignaturePad = ({ onSave, initialValue }) => {
  const sigPad = useRef(null);

  useEffect(() => {
    if (initialValue && sigPad.current) {
      sigPad.current.fromDataURL(initialValue);
    }
  }, [initialValue]);

  const handleEnd = () => {
    if (sigPad.current) {
      const signatureData = sigPad.current.toDataURL();
          onSave(signatureData);
    }
  };

  const handleClear = () => {
    if (sigPad.current) {
      sigPad.current.clear();
      onSave("");
    }
  };

  return (
    <div>
      <SignatureCanvas
        ref={sigPad}
        penColor="black"
        canvasProps={{ width: 300, height: 100, className: "signature-canvas" }}
        onEnd={handleEnd}
      />
      <button
        type="button"
        onClick={handleClear}
        className="signature-clear-btn"
      >
        Clear
      </button>
    </div>
  );
};
export default SignaturePad;